import React from 'react';
import {connect} from "react-redux";
import { ValidatorForm } from 'react-material-ui-form-validator';
import * as actionCreators from "../../actions/actionCreators"
import Register from "../../component/auth/register.js";

class Registercon extends React.Component{
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.toLogin = this.toLogin.bind(this);

    this.state = {
        formData: {
            email: '',
            firstname: '',
            surname: '',
            organisations: [],
            password: '',
            repeatPassword: '',
        },
        submitted: false,
        valid: true
    };

  }

  componentWillMount() {
      /* import les organisations */
      this.props.getOrganisationsAction();

      // custom rule will have name 'isPasswordMatch'
      ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
          if (value !== this.state.formData.password) {
              return false;
          }
          return true;
      });

      if (this.props.isLoggedIn) {
        this.props.history.replace('/');
      }
  }

  handleInputChange(event) {
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    if (this.state.formData.organisations.length > 0) {
      this.setState({formData, valid:true})
    }
    this.setState({ formData });
  }

  toLogin() {
    this.props.history.replace('/login');
  }

  handleFormSubmit(e){
    e.preventDefault();

    if (this.state.formData.organisations.length === 0) {
      this.setState({valid:false})
    } else {
        this.setState({ submitted: true, valid:true }, () => {
          let clone = Object.assign({}, this.state.formData);
          delete clone.repeatPassword
          this.props.registerAction(clone)
          .then(res => {
            this.props.history.replace('/login')
            this.setState({
              submitted: false
            })
          })
          .catch(err => {
            this.setState({
              submitted: false
            })
          })
      });
    }
  }

  render(){
    return <Register
      formData={this.state.formData}
      submitted={this.state.submitted}
      handleFormSubmit={this.handleFormSubmit}
      handleInputChange={this.handleInputChange}
      handleSelectChange={this.handleSelectChange}
      toLogin={this.toLogin}
      user={this.props.user}
      listOfOrganisations={this.props.listOfOrganisations}
      valid={this.state.valid}
    ></Register>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Registercon);



// WEBPACK FOOTER //
// ./src/container/auth/register-container.js